import * as React from 'react';
import { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProps {
  text?: string;
  status?: 'default' | 'error' | 'success';
}

const HelpText = ({ text, status }: IProps): ReactElement => (
  <div
    className={twMerge(
      'help-text',
      status === 'error' && 'text-form-status-error'
    )}>
    {text}
  </div>
);

export default HelpText;
